import { handleActions } from 'redux-actions';
import immutable from 'immutability-helper';
import { ActionTypes } from '../constants';

const initialState = {
    status: 'idle',
    messageCount: 0,
    messageHistory: [
        {
            id: 1,
            time: '10:30:25',
            number: '628123456789',
            status: 'sent',
            message: 'Halo, selamat pagi!',
        },
        {
            id: 2,
            time: '10:28:15',
            number: '628987654321',
            status: 'delivered',
            message: 'Promo spesial untuk Anda',
        },
        {
            id: 3,
            time: '10:25:30',
            number: '628555555555',
            status: 'read',
            message: 'Konfirmasi order #12345',
        },
    ],
    isSendingMessage: false,
    error: null,
    response: Object.assign({}),
};

export const messageState = { ...initialState };

export default {
    wa_message: handleActions(
        {
            // Reset state
            [ActionTypes.RESET_MESSAGE_STATE]: state => immutable(state, {
                status: { $set: 'idle' },
                messageCount: { $set: 0 },
                messageHistory: { $set: initialState.messageHistory },
                isSendingMessage: { $set: false },
                error: { $set: null },
                response: { $set: {} },
            }),

            // Send message - loading
            [ActionTypes.MESSAGE_SEND]: state => immutable(state, {
                status: { $set: 'sending' },
                isSendingMessage: { $set: true },
                error: { $set: null },
            }),

            // Send message success
            [ActionTypes.MESSAGE_SEND_SUCCESS]: (state, { payload }) => {
                const newMessage = {
                    id: Date.now(),
                    time: new Date().toLocaleTimeString(),
                    ...payload,
                    status: 'sent',
                };
                return immutable(state, {
                    status: { $set: 'success' },
                    messageCount: { $set: state.messageCount + 1 },
                    messageHistory: { $unshift: [newMessage] },
                    isSendingMessage: { $set: false },
                    response: { $set: payload },
                });
            },

            // Send message failed
            [ActionTypes.MESSAGE_SEND_FAILED]: (state, { payload }) => immutable(state, {
                status: { $set: 'error' },
                isSendingMessage: { $set: false },
                error: { $set: payload },
            }),

            // Update message status
            [ActionTypes.MESSAGE_UPDATE_STATUS]: (state, { payload }) => {
                const { id, status } = payload;
                const index = state.messageHistory.findIndex(m => m.id === id);
                if (index === -1) return state;

                return immutable(state, {
                    messageHistory: {
                        [index]: {
                            status: { $set: status },
                        },
                    },
                });
            },

            // Reset count
            [ActionTypes.MESSAGE_RESET_COUNT]: state => immutable(state, {
                messageCount: { $set: 0 },
            }),
        },
        initialState
    ),
};